import React, { useRef, useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import "../styles/CardCarousel.scss";
import imgtest from "../assets/aquecedor.png";
import img1 from "../assets/house_th.jpg";
import aquecedor_a_gas from "../assets/aquecedor_a_gas.png";
import coletor_solar_piscina from "../assets/coletor_solar_piscina.png";
import boiler from "../assets/boiler.png";
import coletor_solar_banho from "../assets/coletor_solar_banho.png";
import bomba_pisicina from "../assets/bomba_piscina.png";
import bomba_pressao from "../assets/bomba_pressurizaçao.png";
const ITEMS = [
  {
    title: "Aquecedores de Passagem a Gás",
    subtitle:
      "Os aquecedores de passagem oferecem aquecimento instantâneo, sem desperdício. Compactos, modernos e eficientes, são ideais para quem busca conforto e economia no dia a dia.",
    img: aquecedor_a_gas,
    backgroundImage: aquecedor_a_gas,
    target: "/aquecedor",
  },
  {
    title: "Aquecimento de Piscina",
    subtitle:
      "Os sistemas de aquecimento para piscina garantem água quente e conforto térmico em qualquer estação. Práticos, econômicos e eficientes, elevam a temperatura da água de forma segura e contínua, prolongando os momentos de lazer com sua família.",
    img: coletor_solar_piscina,
    backgroundImage: coletor_solar_piscina,
    target: "/piscina",
  },
  {
    title: "Boilers",
    subtitle:
      "Os boilers armazenam e mantêm a água aquecida com eficiência, garantindo conforto imediato em diversos pontos da casa. Perfeitos para quem busca alta capacidade, durabilidade e economia a longo prazo.",
    img: boiler,
    backgroundImage: boiler,
    target: "/boiler",
  },
  {
    title: "Aquecimento Solar para Banho",
    subtitle:
      "O aquecimento solar para banho utiliza a energia do sol para aquecer a água, proporcionando conforto térmico com baixo custo e impacto ambiental. Ideal para quem busca eficiência, economia e respeito ao meio ambiente.",
    img: coletor_solar_banho,
    backgroundImage: coletor_solar_banho,
    target: "/coletor",
  },
  {
    title: "Bombas de Pressurização",
    subtitle:
      "As bombas de pressurização garantem mais conforto no uso de chuveiros, torneiras e aquecedores, mantendo o fluxo de água forte e constante. Silenciosas, compactas e eficientes, são perfeitas para eliminar problemas de baixa pressão.",
    img: bomba_pressao,
    backgroundImage: bomba_pressao,
    target: "/bomba",
  },
  {
    title: "Bombas de Piscina",
    subtitle:
      "As bombas de piscina são essenciais para a circulação e filtragem da água, garantindo uma piscina sempre limpa, segura e pronta para o uso. Robustas, silenciosas e de alto desempenho, são ideais para uso residencial ou comercial.",
    img: bomba_pisicina,
    backgroundImage: bomba_pisicina,
    target: "/aquaflow",
  },
];

export default function CardCarousel({ perPage = 4 }) {
  const carouselRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(ITEMS.length / perPage);

  // 1) Scroll‑into‑view trigger
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (carouselRef.current) obs.observe(carouselRef.current);
    return () => obs.disconnect();
  }, []);

  // 2) Handlers for Prev/Next
  const prev = () => setPage((p) => Math.max(p - 1, 0));
  const next = () => setPage((p) => Math.min(p + 1, totalPages - 1));

  return (
    <section className="card-carousel-section py-5" ref={carouselRef}>
      <h2 className="text-center mb-4">Soluções e serviços</h2>
      <div className="carousel-container">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${page * 100}%)`,
          }}
        >
          {ITEMS.map((item, idx) => (
            <Card
              key={idx}
              className={`carousel-card ${visible ? "visible" : ""}`}
              style={{
                "--i": idx % perPage,
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${item.backgroundImage})`,
              }}
            >
              <div className="card-img-wrapper">
                <Card.Img src={item.img} alt={item.title} />
                <a target="_blank" href={item.target}>
                  <div className="icon-overlay">
                    <svg width="24" height="24" fill="#fff" viewBox="0 0 24 24">
                      <path
                        d="M5 12h14M12 5l7 7-7 7"
                        stroke="#fff"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </div>
                </a>
              </div>
              <Card.Body>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text>{item.subtitle}</Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
      <div className="controls text-center mt-3">
        <Button
          variant="light"
          onClick={prev}
          disabled={page === 0}
          className="me-2"
        >
          ←
        </Button>
        <Button
          variant="light"
          onClick={next}
          disabled={page === totalPages - 1}
        >
          →
        </Button>
      </div>
    </section>
  );
}
